const Text: React.FC = ({ children }) => (
  <td className="w-20  leading-normal inline-block text-lg ">{children}</td>
);

export default Text;
